// Func = limiting Scope for this file
var lastScrollTop = 0;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;


if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function getImageDimensions(url) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			resolve({ width: img.width, height: img.height });
		};
		img.onerror = (err) => {
			reject('Error loading image');
		};
		img.src = url;
	});
}

function resizeWindow(){
	windowWidth = window.innerWidth;
	windowHeight = window.innerHeight;

	
	

	if(windowWidth > 900){
		//hours to intro content
		if(document.querySelector('.js-add-intro')){
			let introContainer = document.querySelector('#intro-content .column:first-child');
			introContainer.appendChild(document.querySelector('.js-add-intro'));
		}
	}

	if(windowWidth < 600){
		//responsive image:
		if(document.querySelectorAll('.js-responsive-img').length > 0){
			document.querySelectorAll('.js-responsive-img').forEach( img => {
				if(!img.classList.contains('changed')){
					img.classList.add('changed');
					img.src = img.dataset.mobile;
				}
			})
		}
	} else {
		//responsive image:
		if(document.querySelectorAll('.js-responsive-img').length > 0){
			document.querySelectorAll('.js-responsive-img').forEach( img => {
				if(img.classList.contains('changed')){
					img.classList.remove('changed');
					img.src = img.dataset.desktop;
				}
			})
		}
	}
}

(function(){

	window.addEventListener('resize', function() {
        resizeWindow();
	});
	resizeWindow();

	document.querySelectorAll('.js-menu-burger').forEach( menu => {
		menu.addEventListener('click', function(){
			document.querySelector('.main-nav').classList.toggle('open');
			document.querySelector('header').classList.toggle('open');
		});
	})

	if(document.querySelector('.js-close-burger')){
		document.querySelector('.js-close-burger').addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('.main-nav').classList.toggle('open');
			document.querySelector('header').classList.toggle('open');
		});
	}


	if(document.querySelectorAll('.btn').length > 0){
		document.querySelectorAll('.btn').forEach( btn => {
			if(btn.querySelector('span') === null){
				let span = document.createElement('span');
				span.innerHTML = btn.innerHTML;
				btn.innerHTML = '';
				btn.appendChild(span);
			}
		})
	}

	//hours
	if(document.querySelectorAll('.js-hours-block').length > 0){
		document.querySelectorAll('.js-hours-block').forEach( block => {
			let introContainer = document.querySelector('#intro-content');
			introContainer.classList.add('with-hours')
			// introContainer.appendChild(block);
		})
	}

  

	// Main nav gallery active on load
	let mainNavLinks =  (windowWidth < 600 && document.querySelectorAll('.mobile-navigation').length > 0) ? document.querySelectorAll('.mobile-navigation > ul > li') :  document.querySelectorAll('#privary-navigation > li');
	if(document.querySelectorAll('.js-main-img').length > 0){
		let activeLink = false;
		mainNavLinks.forEach((li, index) => {
			let liIndex = index;
			
			li.querySelectorAll('a').forEach((a) => {
				if(a.classList.contains('active')){
					document.querySelectorAll('.js-main-img').forEach((img) => {img.classList.remove('active')});
					activeLink = liIndex;
				}
			});
			(activeLink !== false) ?  (document.querySelectorAll('.js-main-img')[activeLink] ? document.querySelectorAll('.js-main-img')[activeLink].classList.add('active') : null )  : null;
			if (activeLink !== false && li.querySelector('a').nextElementSibling && activeLink===index)  {
				let nextUlHeight = 0;
				li.querySelector('a').nextElementSibling.querySelectorAll('li').forEach((list) => { nextUlHeight += list.offsetHeight; })
				li.querySelector('a').nextElementSibling.style.height = `${nextUlHeight}px`;
				li.querySelector('a').nextElementSibling.classList.add('hover');
			}
		});
	}
	if(document.querySelector('.accommodations-nav')){
		document.querySelector('.accommodations-nav').querySelectorAll('a').forEach((a) => {
			let linkHref = a.getAttribute('href');
			if(Array.from(document.querySelector('body').classList).some(cls => linkHref.includes(cls))){
				a.classList.add('active');
			}
		})
	}
	// Main Navigation Hover Effect
	
	mainNavLinks.forEach((link, index) => {
		let navIndex = index;
		let nextUl = (link.querySelector('a').nextElementSibling ) ? link.querySelector('a').nextElementSibling : null;
		let nextUlHeight = 0;
		if(nextUl){
			nextUl.querySelectorAll('li').forEach((li) => {
				nextUlHeight += li.offsetHeight;
			})
		}
		link.addEventListener('click', () => {
			mainNavLinks.forEach((li) => {
				if(li.querySelector('a').nextElementSibling){ 
					li.querySelector('a').nextElementSibling.classList.remove('hover');
					li.querySelector('a').nextElementSibling.style.height = `0px`;
				}
			});
			if(nextUl){
				nextUl.style.height = `${nextUlHeight}px`;
				nextUl.classList.add('hover');
			}
		})
		link.querySelectorAll('a').forEach((a) => {
			a.addEventListener('click', (e) => {
				if(a.nextElementSibling){
					e.preventDefault();
				}
			})
		})
		
		link.addEventListener('mouseenter', () => {
			(document.querySelectorAll('.js-main-img').length > 0) ? document.querySelectorAll('.js-main-img').forEach((img) => img.classList.remove('active')) : null;
			(document.querySelectorAll('.js-main-img').length > 0) && (document.querySelectorAll('.js-main-img').length > navIndex) ? document.querySelectorAll('.js-main-img')[navIndex].classList.add('active') : null;
		})
		link.addEventListener('mouseleave', () => {
			(document.querySelectorAll('.js-main-img').length > 0) ? document.querySelectorAll('.js-main-img').forEach((img) => img.classList.remove('active')) : null;
			(document.querySelectorAll('.js-main-img').length > 0) && (document.querySelectorAll('.js-main-img').length > navIndex) ? document.querySelectorAll('.js-main-img')[0].classList.add('active') : null;
		})
	
	});

	//cms form focus animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}
	if(document.querySelectorAll('.field').length > 0){
		document.querySelectorAll('.field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

	//track view menu
	document.querySelectorAll('a').forEach( link => {
		if(!link.dataset.section){
			if(link.textContent.toLowerCase().indexOf('menu') > -1){
				link.dataset.section = 'track-menu'
			}
		}
	})
	

	//remove paddings :( 
	if(document.querySelectorAll('.intro-content').length > 0){
		document.querySelectorAll('.intro-content').forEach( intro => {
			if(intro.nextElementSibling.classList.contains('no-padding')){
				intro.classList.add('no-padding');
			}
		})
	}

	//map tabs
	if(document.querySelectorAll('.js-map-tab').length > 0){
		document.querySelectorAll('.js-map-tab').forEach( tab => {
			tab.addEventListener('click', () => {
				let dataTab = tab.getAttribute('data-target');
				document.querySelectorAll('.js-map-tab').forEach( tab => { tab.classList.remove('active');});
				document.querySelectorAll('.js-map-container').forEach( map => { map.classList.remove('active');});
				document.querySelectorAll('[data-target="'+dataTab+'"]').forEach(map => { map.classList.add('active');})
			})
		});	
	}

	//accordion cards
	if(document.querySelectorAll('.js-card-accordion').length > 0){
		document.querySelectorAll('.js-card-accordion').forEach( card => {
			card.addEventListener('click', () => {
				document.querySelectorAll('.js-card-accordion').forEach( c => { c.classList.remove('hover');});
				card.classList.add('hover');
			});
		})
	}
	

	//cards
	if(document.querySelectorAll('.js-card-stacked').length > 0){
		document.querySelectorAll('.js-card-stacked').forEach( card => {
			card.addEventListener('click', () => {
				document.querySelectorAll('.js-card-stacked').forEach( c => { c.classList.remove('hover');});
				card.classList.add('hover');
			});
		})
	}
	
	

	// accordion
	if(document.querySelectorAll('.js-accordion-item').length > 0){
		document.querySelectorAll('.js-accordion-item').forEach( item => {
			
			item.addEventListener('click', () => {
				document.querySelectorAll('.js-accordion-item').forEach( i => { 
					i.parentElement.classList.remove('active');
					i.parentElement.setAttribute('aria-expanded',false);
					i.nextElementSibling.classList.add('hidden');
				});
				item.parentElement.classList.add('active');
				item.parentElement.setAttribute('aria-expanded',true);
				item.nextElementSibling.classList.remove('hidden');
			});
		})
	}

    window.onload = function() {
		
		if(document.querySelector('#home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.querySelector('header').classList.add('down');
			document.querySelector('.js-book-now') ? document.querySelector('.js-book-now').classList.remove('white') : null;
		}

	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	const flexGallery = new LBX('.lbx-main-gallery', {});
	const ImagesLightbox = new LBX('.js-img-lbx', {});
	const menusLbx = new LBX('.lbx-btn', {});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
			// document.querySelector('.js-logo-switch').setAttribute('src',document.querySelector('.js-logo-switch').getAttribute('data-altsrc'));
			document.querySelector('.js-book-now').classList.remove('white')
		}
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
			// document.querySelector('.js-logo-switch').setAttribute('src',document.querySelector('.js-logo-switch').getAttribute('data-src'));
			document.querySelector('.js-book-now').classList.add('white')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
